
function Tabs({ tabs, activeTab, onTabChange, classNames = {} }) {
  return (
    <div className={classNames.container || "tabs-container"}>
      {Object.entries(tabs).map(([key, cfg]) => (
        <button
          key={key}
          onClick={() => onTabChange(key)}
          className={`${classNames.button || "tab-btn"} ${
            activeTab === key ? classNames.active || "active" : ""
          }`}
        >
          {cfg.label}
        </button>
      ))}
    </div>
  );
}

export default Tabs;
 
